
const FarInfraredContentSection = () => {
  return (
    <section className="py-6 md:py-20 bg-white">
      <div className="container max-w-7xl mx-auto px-6 lg:px-8">
        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {/* Stress Reduction */}
          <div className="bg-[#FBF7F7] rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-xl font-bold text-[#00889D] mb-4">Stress Reduction</h3>
            <p className="text-gray-600 leading-relaxed">
              Far infrared heat promotes deep relaxation and helps reduce stress. Let the gentle warmth calm your mind and body as tension melts away during your practice.
            </p>
          </div>

          {/* Detox Inside & Out */}
          <div className="bg-[#FBF7F7] rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-xl font-bold text-[#00889D] mb-4">Detox Inside & Out</h3>
            <p className="text-gray-600 leading-relaxed">
              Radiant far infrared heat encourages deep, cleansing sweat that helps your body naturally eliminate impurities and toxins, enhancing skin tone and clarity—leaving you feeling refreshed, revitalized, and glowing from the inside out.
            </p>
          </div>

          {/* Pain Relief */}
          <div className="bg-[#FBF7F7] rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-xl font-bold text-[#00889D] mb-4">Pain Relief</h3>
            <p className="text-gray-600 leading-relaxed">
              The deep, penetrating warmth of far infrared heat helps ease muscle soreness, joint stiffness, and inflammation. By boosting circulation and promoting relaxation, it supports natural recovery and provides gentle soothing pain relief.
            </p>
          </div>

          {/* Boosted Immunity */}
          <div className="bg-[#FBF7F7] rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-xl font-bold text-[#00889D] mb-4">Boosted Immunity</h3>
            <p className="text-gray-600 leading-relaxed">
              Practice in a far infrared environment may help support a healthy immune system. The gentle heat encourages circulation and may stimulate the body's natural production of white blood cells, which play a key role in defending against illness.
            </p>
          </div>

          {/* Enhanced Circulation */}
          <div className="bg-[#FBF7F7] rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-xl font-bold text-[#00889D] mb-4">Enhanced Circulation</h3>
            <p className="text-gray-600 leading-relaxed">
              Far infrared heat promotes healthy blood flow by gently relaxing blood vessels and improving circulation. This enhanced circulation increases oxygen and nutrient delivery to your cells, supporting overall health, recovery and wellbeing.
            </p>
          </div>

          {/* Weight Loss */}
          <div className="bg-[#FBF7F7] rounded-2xl p-8 shadow-lg border border-gray-100">
            <h3 className="text-xl font-bold text-[#00889D] mb-4">Weight Loss</h3>
            <p className="text-gray-600 leading-relaxed">
              Far infrared heat gently boosts metabolism and encourages greater calorie burn, helping you move deeper and work toward your wellness goals with every session.
            </p>
          </div>
        </div>

        {/* Safety Note */}
        <div className="text-center">
          <p className="text-sm text-gray-500 max-w-4xl mx-auto leading-relaxed">
            * Far infrared heat is generally safe for most people, but please consult your doctor if you have any health concerns. For safety reasons, pregnant women are not recommended in Far Infrared classes, and kids workshops are always conducted in a non-heated room.
          </p>
        </div>
      </div>
    </section>
  );
};

export default FarInfraredContentSection;
